import { Textarea, Text, FormErrorMessage } from '@chakra-ui/core'
import { StyledFormControl, StyledFormLabel } from 'components/AdminConsole/commonUI/styles'
import { useFormContext } from 'react-hook-form'
import React from 'react'
import useLocaleText from 'components/useLocaleText'
import { getNestedError } from 'components/PopCreation/Form/utils'
import { AlignJustify } from 'lucide-react'

const MAX_CONTENT_LENGTH = 1000

export const ContentField = () => {
  const { register, errors } = useFormContext()
  const t_label = useLocaleText('t_content', true)
  const t_placeholder = useLocaleText('content_placeholder', true)
  const error = getNestedError(errors, 'data.content')
  const validation_rule_is_required = useLocaleText('validation_rule_is_required', true)
  const error_content_max_length = useLocaleText('error_content_max_length', true)

  const validationRules = {
    required: validation_rule_is_required,
    maxLength: {
      value: MAX_CONTENT_LENGTH,
      message: error_content_max_length,
    },
  }

  return (
    <StyledFormControl isInvalid={!!error}>
      <StyledFormLabel required>
        <AlignJustify size={18} strokeWidth={2.5} />
        <Text>{t_label}</Text>
      </StyledFormLabel>

      <Textarea
        name="data.content"
        ref={register(validationRules)}
        minH={{ base: '80px', md: '118px' }}
        borderRadius="5px"
        bg="white"
        resize="none"
        border="1px solid"
        placeholder={t_placeholder}
        _focus={{ boxShadow: '0px 0px 0px 1px black' }}
      />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </StyledFormControl>
  )
}
